import { TranslateService } from '@ngx-translate/core';
import { CustomInjector } from '../../services/custom-injector/custom-injector';
import { NotificationIdentifierModel } from '../low-level/notification-identifier.model';
import { NotificationModel } from '../low-level/notification.model';
import { TableModelOptions } from '../options/table-model-options';
import { ColumnModel } from '../primitive/column.model';
import { TextModel } from '../primitive/text.model';
import { ArrayModel } from './array.model';
import { CompositeModel } from './composite.model';
import {
    DataMaintenanceEquipmentModel,
    ODataDataMaintenanceEquipmentOutModel,
} from './data-maintenance-equipment.model';
import { TableModel } from './table.model';
import { ConfigConstants } from '../../config/config-constants';

export class DataMaintenanceSystemConfigP58Model extends CompositeModel {
    public notificationIdentifier: NotificationIdentifierModel;
    public equnr: TextModel;
    public matnr: TextModel;
    public tidnr: TextModel;
    public sernr: TextModel;
    public equiShortDesc: string;
    public pos: number | undefined;
    public name1: TextModel;
    public functionalLoc: TextModel;

    public equipmentSet: ArrayModel<DataMaintenanceEquipmentModel>;
    public tableModel: TableModel<DataMaintenanceEquipmentModel>;
    public readonly isInvitro: boolean;
    public constructor(private notificationModel: NotificationModel) {
        super('DataMaintenanceSystemConfigP58Model');

        const injector = CustomInjector.getInjector();
        const translate = injector.get(TranslateService);
        this.isInvitro = notificationModel.processIndicator === ConfigConstants.PROCESS_INDICATOR.INVITRO;

        this.name1 = new TextModel('Name', notificationModel.address.name1.value);
        this.functionalLoc = new TextModel('FunctionalLoc', this.notificationModel.functionalLoc);

        this.notificationIdentifier = this.notificationModel.identifier;
        this.equipmentSet = <ArrayModel<DataMaintenanceEquipmentModel>>this.set(
            new ArrayModel<DataMaintenanceEquipmentModel>(
                'Equipments',
                this.notificationModel.equipmentSet.map(
                    (e) => new DataMaintenanceEquipmentModel(e, notificationModel.processIndicator),
                ),
            ),
        );

        const columns: ColumnModel[] = [];
        columns.push(
            new ColumnModel(<string>translate.instant('DATA_MAINTENANCE_EQUIPMENT_MATERIAL_ID'), 'matnr.value'),
        );
        columns.push(
            new ColumnModel(<string>translate.instant('DATA_MAINTENANCE_EQUIPMENT_DESCRIPTION'), 'equiShortDesc'),
        );
        columns.push(new ColumnModel(<string>translate.instant('DATA_MAINTENANCE_EQUIPMENT_SERIAL'), 'sernr.value'));
        const tableOptions = new TableModelOptions({ columns, sortColumn: 'pos' });

        this.tableModel = new TableModel<DataMaintenanceEquipmentModel>(this.equipmentSet.value, tableOptions);
    }

    public getOutModel(): ODataDataMaintenanceEquipmentOutModel {
        return <ODataDataMaintenanceEquipmentOutModel>super.getOutModel();
    }
}
